// extracted by mini-css-extract-plugin
export default {"stepNumber":"WizardFooter_stepNumber__Cs6aw","lineSeparator":"WizardFooter_lineSeparator__1dw47"};